module.exports = __webpack_public_path__ + "static/img/hud_right_top_corn.9f5ee576.png";